export function googleFontsStylesheetUrl({ family }: { family: string }): string | null {
  const trimmed = family.trim();
  if (!trimmed) return null;
  const encoded = encodeURIComponent(trimmed).replace(/%20/g, "+");
  return `https://fonts.googleapis.com/css2?family=${encoded}:wght@400;600;700&display=swap`;
}
